import { z } from "zod";

export const loginSchema = z.object({
  email: z.email("E-mail inválido"),
  password: z.string().min(6, "A senha deve ter pelo menos 6 caracteres"),
});

export type LoginFormData = z.input<typeof loginSchema>;

export const signupSchema = loginSchema
  .extend({
    confirmPassword: z
      .string()
      .min(6, "Password must be at least 6 characters"),
    optInMarketing: z.boolean().default(false),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

export type SignupFormData = z.input<typeof signupSchema>;

/** Step 1: Email */
export const signupEmailSchema = z.object({
  email: z.email("E-mail inválido"),
});
export type SignupEmailFormData = z.input<typeof signupEmailSchema>;

/** Step 2: Verification code */
export const signupCodeSchema = z.object({
  code: z
    .string()
    .length(6, "O código deve ter 6 dígitos")
    .regex(/^\d+$/, "O código deve conter apenas números"),
});
export type SignupCodeFormData = z.input<typeof signupCodeSchema>;

/** Step 3: Password + confirm */
export const signupPasswordSchema = z
  .object({
    password: z.string().min(6, "A senha deve ter pelo menos 6 caracteres"),
    confirmPassword: z
      .string()
      .min(6, "A senha deve ter pelo menos 6 caracteres"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "As senhas não coincidem",
    path: ["confirmPassword"],
  });
export type SignupPasswordFormData = z.input<typeof signupPasswordSchema>;

/** Reset password wizard schemas (aliases of signup schemas) */
export const resetEmailSchema = signupEmailSchema;
export type ResetEmailFormData = SignupEmailFormData;

export const resetCodeSchema = signupCodeSchema;
export type ResetCodeFormData = SignupCodeFormData;

export const resetPasswordSchema = signupPasswordSchema;
export type ResetPasswordFormData = SignupPasswordFormData;
